import cx from 'classnames';

import styles from './questionHeader.module.less';

export const QuestionHeading: React.FC<{
  className?: string;
  isRedesignedInquiryFlow?: boolean;
}> = ({ className, isRedesignedInquiryFlow, children }) => {
  return (
    <h2
      className={cx(styles.header, className, {
        [styles.redesignHeader]: isRedesignedInquiryFlow,
      })}
      id="inquiry-modal-header"
      data-testid="inquiry-question-header"
    >
      {children}
    </h2>
  );
};
